import HeroSection from './components/HeroSection';
import DirectCTASection from './components/DirectCTASection';
import ProblemSolution from './components/ProblemSolution';
import OneStopSection from './components/OneStopSection';
import BenefitSection from './components/BenefitSection';
import FlowSection from './components/FlowSection';
import TestimonialsSection from './components/TestimonialsSection';
import AuthoritySection from './components/AuthoritySection';
import SafetyBadgeSection from './components/SafetyBadgeSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ItemCatalogSection from './components/ItemCatalogSection';
import WhyWePayMoreSection from './components/WhyWePayMoreSection';
import Navbar from '../../components/feature/Navbar';
import FloatingCTA from '../../components/feature/FloatingCTA';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div id="hero">
        <HeroSection />
      </div>
      <DirectCTASection />
      <ProblemSolution />
      <div id="catalog">
        <ItemCatalogSection />
      </div>
      <WhyWePayMoreSection />
      <OneStopSection />
      <div id="benefit">
        <BenefitSection />
      </div>
      <div id="flow">
        <FlowSection />
      </div>
      <div id="testimonials">
        <TestimonialsSection />
      </div>
      <div id="authority">
        <AuthoritySection />
      </div>
      <SafetyBadgeSection />
      <div id="faq">
        <FAQSection />
      </div>
      <div id="cta" className="pb-20 md:pb-0">
        <CTASection />
      </div>
      <Footer />
      <FloatingCTA />
    </div>
  );
}